import { render, staticRenderFns } from "./BarChartLabels.vue?vue&type=template&id=18bbf974&"
import script from "./BarChartLabels.vue?vue&type=script&lang=js&"
export * from "./BarChartLabels.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports